// This script must be loaded after Alpine or in <head> so the snippet can call it.
window.handleFilterChange = async function(formId) {
  // 1) Find the form
  const form = document.getElementById(formId);
  if (!form) {
    console.error(`Form not found: ${formId}`);
    return;
  }

  // 2) Collect the filter data
  const formData = new FormData(form);
  const params = new URLSearchParams(formData).toString();

  // 3) Decide which sub-collection handle to fetch
  //    If you’re in a "parent-tabs" environment (like your `collection__parent-tabs.liquid`),
  //    you might have to figure out which tab is active. 
  //    For example:
  let activeTabIndex = window.mySubCollectionsState?.activeTabIndex || 0;
  let childHandle = window.mySubCollectionsState?.subcollections[activeTabIndex]?.handle;

  // If your code doesn’t store subcollection state in “mySubCollectionsState,” 
  // you need some other way to know the handle. 
  // For instance, if there’s only 1 sub-collection in this context, hardcode childHandle.

  if (!childHandle) {
    console.error("No childHandle found. Possibly only one sub-collection or product?");
    return;
  }

  // 4) Build the sub-collection AJAX URL 
  //    e.g. /collections/<handle>?view=subcollection-ajax&filter param
  const url = `/collections/${childHandle}?view=subcollection-ajax&${params}`;
  console.log("Filter AJAX URL:", url);

  // 5) Fetch the filtered HTML
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const html = await response.text();

    // 6) Replace the HTML in the current tab’s container
    //    We know from your code that the container is something like:
    //    <div x-html="loadedCollections[activeTabIndex].html"></div>
    //    So we need to directly manipulate that. 
    //    Or if your code uses "this.loadedCollections[activeTabIndex]" inside Alpine,
    //    we can manually set that. For simplicity:
    const container = document.querySelector('[x-html="loadedCollections[activeTabIndex].html"]');
    if (container) {
      container.innerHTML = html;

      console.log("Updated the sub-collection HTML with filtered results.");

      // 7) Re-run any scripts needed for new content:
      if (window.initTooltips) window.initTooltips();
      if (window.initMenuDropdowns) window.initMenuDropdowns();
      if (window.initToleranceModals) window.initToleranceModals();
      if (window.initFilters) window.initFilters(activeTabIndex);

    } else {
      console.error("Couldn’t find the container to update. Check your markup.");
    }

  } catch (err) {
    console.error("Error during filter AJAX request:", err);
  }
}
